import { BaseService } from './BaseService';
import { LegalDocument } from '../types';

class DocumentService extends BaseService {
  constructor() {
    super('/api/documents');
  }

  // Récupère les n derniers actes enregistrés (triés par CreatedOn décroissant côté API)
  async getDocuments(count = 10): Promise<LegalDocument[]> {
    try {
      const items = await this.get<any[]>(`/recent?count=${count}`);
      if (!Array.isArray(items)) return [];

      return items.map(item => ({
        id: item.id || item.Id,
        nature: item.categoryName || item.CategoryName || 'Acte',
        categoryName: item.categoryName || item.CategoryName || 'Acte',
        referenceNumber: item.referenceNumber || item.ReferenceNumber || '',
        officialTitle: item.officialTitle || item.OfficialTitle || '',
        legalOrigin: item.legalOrigin || item.LegalOrigin || 'National',
        dateOfAdoption: item.dateOfAdoption || item.DateOfAdoption || '',
        effectiveDate: item.effectiveDate || item.EffectiveDate || '',
        effectiveYear: item.effectiveYear || item.EffectiveYear || new Date().getFullYear(),
        areaOfLaw: item.areaOfLaw || item.AreaOfLaw || '',
        scopeOfApplication: item.scopeOfApplication || item.ScopeOfApplication || null,
        legalStatus: item.legalStatus || item.LegalStatus || '',
        groupStatus: item.groupStatus || item.GroupStatus || null,
        issuingAuthority: item.issuingAuthority || item.IssuingAuthority || '',
        legalKeywords: item.legalKeywords ? (item.legalKeywords || item.LegalKeywords).split(';').map((k: string) => k.trim()) : [],
        totalPages: item.totalPages || item.TotalPages || null,
        createdOn: item.createdOn || item.CreatedOn,
        fileUrl: `/api/documents/${item.id || item.Id}/view-stream`,
        isLocked: item.isLocked ?? item.IsLocked ?? false,
        hasSummary: item.hasSummary ?? item.HasSummary ?? false,
        hasJurisdiction: item.hasJurisdiction ?? item.HasJurisdiction ?? false,
        hasDate: item.hasDate ?? item.HasDate ?? false,
        hasPdf: item.hasPdf ?? item.HasPdf ?? false,
      }));
    } catch (error) {
      console.error('DocumentService.getDocuments error', error);
      return [];
    }
  }

  async getDocumentById(id: string | number): Promise<LegalDocument | null> {
    try {
      const item = await this.get<any>(`/${id}`);
      if (!item) return null;

      // Transform backend DTO to frontend LegalDocument type
      return {
        id: item.id || item.Id,
        nature: item.categoryName || item.CategoryName || 'Acte',
        categoryName: item.categoryName || item.CategoryName || 'Acte',
        referenceNumber: item.referenceNumber || item.ReferenceNumber || '',
        officialTitle: item.officialTitle || item.OfficialTitle || '',
        legalOrigin: item.legalOrigin || item.LegalOrigin || 'National',
        dateOfAdoption: item.dateOfAdoption || item.DateOfAdoption || '',
        effectiveDate: item.effectiveDate || item.EffectiveDate || '',
        effectiveYear: item.effectiveYear || item.EffectiveYear || new Date().getFullYear(),
        areaOfLaw: item.areaOfLaw || item.AreaOfLaw || '',
        scopeOfApplication: item.scopeOfApplication || item.ScopeOfApplication || null,
        legalStatus: item.legalStatus || item.LegalStatus || '',
        groupStatus: item.groupStatus || item.GroupStatus || null,
        issuingAuthority: item.issuingAuthority || item.IssuingAuthority || '',
        legalKeywords: item.legalKeywords ? (item.legalKeywords || item.LegalKeywords).split(';').map((k: string) => k.trim()) : [],
        totalPages: item.totalPages || item.TotalPages || null,
        fileUrl: `/api/documents/${item.id || item.Id}/view-stream`, // Endpoint for streaming PDF
        isLocked: item.isLocked ?? item.IsLocked ?? false,
        hasSummary: item.hasSummary ?? item.HasSummary ?? false,
        hasJurisdiction: item.hasJurisdiction ?? item.HasJurisdiction ?? false,
        hasDate: item.hasDate ?? item.HasDate ?? false,
        hasPdf: item.hasPdf ?? item.HasPdf ?? false,
      };
    } catch (error) {
      console.error('DocumentService.getDocumentById error', error);
      return null;
    }
  }

  async requestDownloadTicket(id: string | number): Promise<string> {
    const response = await this.post<{ ticket: string }>(`/${id}/download-ticket`, {});
    return response.ticket;
  }
}

export const documentService = new DocumentService();
